import { atom } from 'recoil';

/**
 * A request to re-open a patient from the database, set by the save
 * conflict dialog's "discard my changes and reload" action just before it
 * unloads the patient and navigates back to the worklist.
 * {@link OpenInViewerDownloader} consumes-and-clears it on mount and
 * re-runs the standard open flow — there is no parallel reload path.
 */
export type PendingReopenRequest = {
    /** Connector patient row GUID to re-open. */
    patientId: string;
};

export const pendingReopenRequestState = atom<PendingReopenRequest | null>({
    key: 'pendingReopenRequest',
    default: null,
});
